import { Spin, SpinProps } from 'antd';
import React from 'react';
import './loader.scss';

// Define the Loader component, extending all SpinProps
interface LoaderProps extends SpinProps {
  loading: boolean;
  primary?: boolean;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  primary = false,
  loading = true,
  size = 'large',
  delay = 200,
  children,
  className = '',
  ...rest
}) => {
  return (
    <>
      {children ? (
        <Spin
          wrapperClassName={`lnd-loader ${primary ? 'lnd-loader-primary' : ''} ${className}`}
          spinning={loading}
          size={size}
          delay={delay}
          {...rest}
        >
          {children}
        </Spin>
      ) : (
        <div
          className={`lnd-loader lnd-loader-absolute flex justify-center ${primary ? 'lnd-loader-primary' : ''} ${className}`}
        >
          <Spin spinning={loading} size={size} delay={delay} {...rest} />
        </div>
      )}
    </>
  );
};

// Three-dot typing loader component
interface TypingLoaderProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export const TypingLoader: React.FC<TypingLoaderProps> = ({
  className = '',
  size = 'medium',
}) => {
  const sizeClasses = {
    small: 'lnd-typing-loader-small',
    medium: 'lnd-typing-loader-medium',
    large: 'lnd-typing-loader-large',
  };

  return (
    <div className={`lnd-typing-loader ${sizeClasses[size]} ${className}`}>
      <span className="lnd-typing-dot"></span>
      <span className="lnd-typing-dot"></span>
      <span className="lnd-typing-dot"></span>
    </div>
  );
};

export default Loader;
